export default "__VITE_ASSET__DjQ8CPpB__"